import { useSelector } from 'react-redux'

import { ApplicationState } from 'redux/Stores/types'

export const useCurrencyConverter = () => {
  return useSelector(
    (state: ApplicationState) => state.CurrencyConverterStore.currency
  )
}
